import axios from 'axios';
import store from '../store';

export function createOrder(customer, order) {
  return axios.post(`/api/customers/${customer.id}/orders`, order);
}

export function addOrderDetails(order, products) {
  const productsToOrder = [];

  products.forEach((product) => {
    const productToOrder = {
      product_id: product.id,
      product_description: product.description,
      quantity: product.quantity,
      price: product.price,
      total: product.totalPrice,
      total_with_taxes: store.getters['auth/isTaxable'] ? product.totalPriceWithVat : product.totalPrice,
      total_taxes: product.vat,
      tax_rate: product.vat_rate,
    };
    if (product.discount_rate) {
      productToOrder.discount_applied = product.discount_rate;
    }
    productsToOrder.push(productToOrder);
  });
  return axios.post(`/api/orders/${order.id}/details`, { products: productsToOrder });
}

export function getCustomerOrders(customer) {
  return axios.get(`/api/customers/${customer.id}/orders`);
}

export function getSingleOrder(id) {
  return axios.get(`/api/orders/${id}`);
}

export function getCustomerDefaultPaymentMethod(id) {
  return axios.get(`/api/customers/${id}/default-payment-method`);
}

export function getCustomerCards(id) {
  return axios.get(`/api/customers/${id}/payment-methods?type=Cards`);
}

export function getCustomerIbans(id) {
  return axios.get(`/api/customers/${id}/payment-methods?type=Sepas`);
}

export function getCustomerSetupIntent(id) {
  return axios.get(`/api/customers/${id}/intent`);
}

export function getCustomerSepaSetupIntent(id) {
  return axios.get(`/api/customers/${id}/sepa-intent`);
}

export function getCustomerPersonalCoupons(id, available) {
  return axios.get(`/api/customers/${id}/coupons?personal=true${available ? `&available=${available}` : ''}`);
}

export function getAllCustomerCoupons(id, available) {
  return axios.get(`/api/customers/${id}/coupons${available ? `?available=${available}` : ''}`);
}
